export const formatMemoryRecordIdForDisplay = (recordId: string): string => {
  const trimmed = recordId.trim();
  if (!trimmed.includes('/')) {
    return trimmed;
  }

  const memoriesMarker = '/memories/';
  const markerIndex = trimmed.lastIndexOf(memoriesMarker);
  if (markerIndex !== -1) {
    return trimmed.slice(markerIndex + memoriesMarker.length);
  }

  return trimmed.split('/').pop() ?? trimmed;
};
